const LOCAL_HOST = '127.0.0.1:8443'
const HOST = 'moema.wangsheng.top:2083' // ema.eterblizzard.xyz:2083

export const apiUrl = `https://${HOST}/api`
export const devApiUrl = `https://${LOCAL_HOST}/api`
export const socketUrl = `wss://${HOST}/socket`
export const devSocketUrl = `wss://${LOCAL_HOST}/socket`
export const actionCodeContinueUrl = `https://${HOST}/`